import React from 'react';
import HamburguerButton from './HamburgerButton';
import SearchMobile from './SearchMobile';
import MapContentButton from './MapContentButton';

const HeaderMobile = () => {
  return (
    <div className="mobile-toolbar">
      <HamburguerButton />
      <SearchMobile />
      <MapContentButton />
    </div>
  );
};

export default HeaderMobile;
